@if(templateForPermitForm){
  @if (activity.model.reason === completedReason) {
    <div class="activity-message">
      <!-- <p class="mat-body-1">
        You are about to close this application. Please carefully review the
        information entered below before clicking submit.
      </p> -->
      <wm-common-text [data]="{
        text: 'You are about to close this application. Please carefully review the information entered below before clicking submit.'
      }">
      </wm-common-text>

      <wm-application-readonly
        [applicationId]="context.applicationId"
        [activities]="activity.model.activities"
        [isTestApplication]="isTestApplication"
      ></wm-application-readonly>
    </div>
  } @else if (activity.model.reason === rejectedReason) {
    <div class="activity-message">
      <p class="mat-body-1 mat-warn">
        Your application has been rejected.
      </p>
    </div>
  }
}@else{
  <div *ngIf="activity.model.reason == completedReason">
    You are about to close this application. Please carefully review the
    information entered below before clicking submit.
    <wm-application-readonly
      [applicationId]="context.applicationId"
      [activities]="activity.model.activities"
      [isTestApplication]="isTestApplication"
    ></wm-application-readonly>
  </div>
  <div *ngIf="activity.model.reason == rejectedReason">
    Your Application has been rejected.
  </div>
}
